import { render, staticRenderFns } from "./CohortList.vue?vue&type=template&id=4bf18015&"
import script from "./CohortList.vue?vue&type=script&lang=js&"
export * from "./CohortList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports